import { Component, OnInit, TemplateRef, ViewEncapsulation, inject, input, viewChild } from '@angular/core';
import { FieldArrayType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { NgClass } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { MCButtonComponent, MCDialogComponent } from '@maslul/common-components';
import { MCDialog, MCDialogButton, MCDialogFooter, MCDialogHeader } from '@maslul/common-services';


@Component({
  selector: 'mc-formis-field-array',
  templateUrl: './formis-field-array.html',
  styleUrls: ['./formis-field-array.scss'],
  imports: [
    NgClass,
    FormlyModule,
    MCButtonComponent,
    MCDialogComponent
  ],
  encapsulation: ViewEncapsulation.None
})
//todo: move to mc
export class MIFormisFieldArray extends FieldArrayType implements OnInit {

  private translateService = inject(TranslateService);

  isCloseRow: boolean = false;
  formisRepeatText: any;
  formisExpandText: any;
  readonly addButtonText = input<string>('');
  dialogProperties: MCDialog = new MCDialog();
  readonly dialogContentTemplate = viewChild('dialogContentTemplate', { read: TemplateRef });
  labelText: any;

  constructor() {
    super();
    this.initText();

  }


  getAddButtonText(): string {
    const customAddRowTextByFieldName = this.field.id ? this.field.id?.toString() : null;
    if (customAddRowTextByFieldName) {
      const label = this.formisRepeatText?.[customAddRowTextByFieldName];
      if (label) {
        return (this.formisRepeatText?.['addRowPrefix'] ?? '') + ' ' + label;
      }
    }
    const addButtonText = this.addButtonText();
    if (!addButtonText) {
      return this.formisRepeatText?.addRow ?? '';
    }
    return addButtonText;
  }
  ngOnInit(): void {
    this.initDialog();
  }

  initText() {
    this.formisRepeatText = this.translateService.instant("formis.repeat");
    this.formisExpandText = this.translateService.instant("formis.expandSection");
    this.labelText = this.translateService.instant("labels");

  }

  getRowTitle(index: any) {
    const row = this.formisRepeatText.row + " " + (index + 1).toString();
    const title = this.getOfProps('label') ? this.getOfProps('label') + " - " + row : row;
    return title;
  }

  isDisabledTable(): boolean {
    const isDisabled = this.field.props?.['isTableActionsDisabled'] || this.field.props?.disabled || eval(this.props["disabledCondition"]) == true;
    return isDisabled;
  }

  isShowDeleteRow(): boolean {
    const isShow =
      !!(this.field.fieldGroup && this.field.fieldGroup?.length > 1)
      && !this.isDisabledTable();

    return isShow;
  }

  isShowAddRow(): boolean {
    const isShow =
      !this.isMaxedOut() &&
      !this.isDisabledTable();

    return isShow;
  }

  isMaxedOut(): boolean {
    const isMax = this.getOfProps('maxLength') == 0 || !!(this.field.fieldGroup && this.field.fieldGroup?.length >= this.getOfProps('maxLength'));
    return isMax;
  }

  toggleRow(currentField: FormlyFieldConfig) {
    if (currentField.props) {
      const isCloseRow = currentField.props["isCloseRow"];
      this.closeOtherRows();
      currentField.props["isCloseRow"] = !isCloseRow;
    }
    this.isCloseRow = !this.isCloseRow;
  }

  getOfProps(key: string, currentField?: FormlyFieldConfig): any {
    const props = currentField ? currentField.props : this.props;
    return props ? props[key] : null;
  }

  deleteRow(repeatRowNumber: number) {
    this.showDialog(repeatRowNumber);

  }

  closeOtherRows() {
    if (this.field.fieldGroup && this.field.fieldGroup?.length) {
      this.field.fieldGroup.forEach(field => {
        if (field.props && field.props["isCloseRow"] !== true) {
          field.props["isCloseRow"] = true;
        }
      });
    }
  }

  addRow(): void {
    this.closeOtherRows();
    this.add()
  }

  initDialog() {
    this.dialogProperties.breakpoints = {
      '960px': '75vw', // ברוחב 960px ומטה, רוחב הדיאלוג יהיה 75vw
      '640px': '80vw' // ברוחב 640px ומטה, רוחב הדיאלוג יהיה 80
    };
    this.dialogProperties.id = 'mi-remove-repeat-row';

  }

  showDialog(repeatRowNumber: number) {
    this.dialogProperties.visible = true

    this.dialogProperties.header = new MCDialogHeader();
    this.dialogProperties.header.closeButton = new MCDialogButton();
    this.dialogProperties.header.closeButton.label = "X";
    this.dialogProperties.header.closeButton.event = () => { this.dialogProperties.visible = false };

    this.dialogProperties.footer = new MCDialogFooter();
    this.dialogProperties.footer.button = new MCDialogButton();
    this.dialogProperties.footer.button.label = this.formisRepeatText.deleteDialog.deleteBtn;
    this.dialogProperties.footer.button.event = () => {
      this.remove(repeatRowNumber);
      this.dialogProperties.visible = false
    };

    this.dialogProperties.footer.secondButton = new MCDialogButton();
    this.dialogProperties.footer.secondButton.label = this.formisRepeatText.deleteDialog.cancelBtn;
    this.dialogProperties.footer.secondButton.class = "mi-white-button";
    this.dialogProperties.footer.secondButton.event = () => { this.dialogProperties.visible = false };

    const dialogContentTemplate = this.dialogContentTemplate();
    if (dialogContentTemplate) {
      this.dialogProperties.contentTemplate = dialogContentTemplate;
    }
  }
}